import $ from "jquery";

$(document).on("change", ".cart-addon-checkbox", function () {
  var $thischeckbox = $(this);
  var value = $(this).prop("checked") ? "add" : "remove";
  const product_info = $(this).data("product-info");
  var elipsis =
    '<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>';

  if (value === "add") {
    $('label[for="' + $thischeckbox.attr("id") + '"] h3').html(
      "Adding " + product_info.product_title + elipsis
    );
    var data = {
      action: "ql_woocommerce_ajax_add_to_cart",
      product_id: product_info.product_id,
      product_type: "addon",
      quantity: 1,
    };
    $(document.body).trigger("adding_to_cart", [$thischeckbox, data]);

    $.ajax({
      type: "post",
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      success: function (response) {
        if (response.cart_total) {
          $(".price-total").html(response.cart_total);
        }
        $("#" + $thischeckbox.attr("id") + "_text").html("Added");
        $('label[for="' + $thischeckbox.attr("id") + '"] h3').text(
          product_info.product_title
        );
        if (response.error && response.product_url) {
          window.location = response.product_url;
        } else {
          $(document.body).trigger("added_to_cart", [
            response.fragments,
            response.cart_hash,
            $thischeckbox,
          ]);
        }
      },
    });
  } else {
    $('label[for="' + $thischeckbox.attr("id") + '"] h3').html(
      "Removing " + product_info.product_title + elipsis
    );
    var data = {
      action: "ql_woocommerce_ajax_remove_from_cart",
      product_id: product_info.product_id,
    };

    $.ajax({
      type: "post",
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      success: function (response) {
        if (response.cart_total) {
          $(".price-total").html(response.cart_total);
        }
        $('label[for="' + $thischeckbox.attr("id") + '"] h3').text(
          "Add " + product_info.product_title
        );
        if (response.error && response.product_url) {
          window.location = response.product_url;
        } else {
          $(document.body).trigger("removed_from_cart", [
            response.fragments,
            response.cart_hash,
            $thischeckbox,
          ]);
        }
      },
    });
  }
});

// Refresh cart fragments
$(document.body).on(
  "added_to_cart removed_from_cart",
  function (event, fragments) {
    if (fragments) {
      $.each(fragments, function (key) {
        $(key)
          .addClass("updating")
          .fadeTo("400", "0.6")
          .block({
            message: null,
            overlayCSS: { opacity: 0.6 },
          });
      });

      $.each(fragments, function (key, value) {
        $(key).replaceWith(value);
        $(key).stop(true).css("opacity", "1").unblock();
      });

      $(document.body).trigger("wc_fragments_refreshed");
    }
  }
);

jQuery(function () {
  $(".sh-toggle").on("click", function () {
    $(".sh-content").toggleClass("visually-hidden-sm");
    var $this = $(this);
    if ($(".sh-content").hasClass("visually-hidden-sm")) {
      $this.find(".summary").text("Show order summary");
      $this.find(".arrow-up").removeClass("arrow-up").addClass("arrow-down");
    } else {
      $this.find(".summary").text("Hide order summary");
      $this.find(".arrow-down").removeClass("arrow-down").addClass("arrow-up");
    }
  });
});

jQuery(function () {
  $(".addon-toggle").on("click", function () {
    var $this = $(this);
    $this.siblings(".addon-content").removeClass("visually-hidden-sm");
    $this.addClass("visually-hidden-sm");
  });
});
